import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface InputDialogData {
    title: string;
    text: string;
    userInput?: string;
    cancelLabel?: string;
    submitLabel?: string;
}

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['../dialog.styles.scss'],
})
export class InputDialogComponent implements AfterViewInit {
    public title!: string;
    public text!: string;
    public userInput!: string;
    public cancelLabel!: string;
    public submitLabel!: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: InputDialogData,
        private cd: ChangeDetectorRef
    ) {
        this.title = data.title;
        this.text = data.text;
        this.userInput = data.userInput || '';
        this.cancelLabel = data.cancelLabel || 'Annuleren';
        this.submitLabel = data.submitLabel || 'Opslaan';
    }

    public ngAfterViewInit() {
        this.cd.detectChanges();
    }
}
